import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Checkbox from "rc-checkbox";
import findIndex from "lodash/findIndex";
import { connect } from "react-redux";
import filter from "lodash/filter";
import SortableList, { SortableItem } from "react-easy-sort";
import { arrayMoveImmutable } from "array-move";
import { BsInfoCircle } from "react-icons/bs";

import {
  Card,
  CardBody,
  CardImg,
  Button,
  CardTitle,
  CardText,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Table,
} from "reactstrap";
import DashboardChartItem from "./DashboardChartItem";
import Loading from "../../../../../hoc/Loading/Loading";
import axios from "../../../../../axios";
import * as actionCreators from "../../../../../modules/actions/index";
import * as url from "../../../../../utils/url";
import { ensureMappings } from "../../../../../utils/ensureMappings";
import LinkChart from "../../../../../assets/placeholders/dashboard_sample.png";
import { dashboardChartSize } from "../../../../../utils/constants";
import NoKpiPlaceholder from "../../../../../assets/placeholders/no_kpi_available.svg";
import { deepClone } from "../../../../../utils/copyObject";
import DashboardNotesList from "../AddNotes/DashboardNotesList";
import { isEmpty as blankObj } from "lodash";
import DashboardChartPlot from "./DashboardChartPlot";

class DashboardChartList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      updatedFields: [],
      title: "",
      chartsUpdated: 0,
      isChartList: false,
      isUpdateData: false,
      charts: [],
      isEmpty: false,
      isUpdated: false,
      length_df: 0,
      newCharts: [],
      hideCharts: false,
      dashboardDateUpdate: this.props.dashboardDateUpdate,
      tools: [],
      dashboardTools: [],
      // isCategory:this.props.reports.isCategory,
      isCategory: [],
      currentDashboard: this.props.currentDashboard,
      linkedItems: [],
      allItems: [],
      linkedItemsCount: null,
      isResourceSelect: this.props.isResourceSelect,
      searchedTerm: "",
      chartOrder: [],
      reportCharts: [],
    };
  }

  componentDidMount() {
    console.log("load charts ----");
    this.fetchCharts();
    // Prefetch org mappings in the background so the first date-change refresh
    // doesn't wait on the mappings request (refreshChart also ensures them on demand).
    ensureMappings(
      this.props.user.profile.organizationId,
      this.props.mappingMaster.mappingMasterList,
      this.props.onMappingMasterListFetched
    ).catch(error => {
      console.log("error prefetching mapping master list: ", error);
    });
  }

  // ((current_st!=null && prev_st!=null&&current_st.join(',')!=prev_st.join(',')) || (prev_st==null && current_st!=null && current_st.length>0 )
  //   || (prev_st==null && current_st!=null && prev_st.length>0 )
  //   )

  componentDidUpdate(prevProps, prevState) {
    let prev_st =
      prevProps.reports.isCategory == null ? [] : prevProps.reports.isCategory;
    let current_st = this.props.reports.isCategory;
    let { reports } = this.props;
    let { dashboardDateUpdate, chartOrder, isCategory } = this.state;
    // let cRepDate = new Date(reports.dashboardDateUpdate).getTime()
    // let dRepDate = new Date(dashboardDateUpdate).getTime()

    // console.log('testing---')
    // if(dashboardDateUpdate && dRepDate!=cRepDate){

    //   this.updateAllCharts(reports.dashboardDateUpdate)
    // }

    // if(reports.charts != prevProps.reports.charts){

    // }

    if (
      (reports.charts.length < chartOrder.length &&
        prevProps.reports.charts.length != reports.charts.length) ||
      reports.charts != prevProps.reports.charts
    ) {
      const orderedCharts = chartOrder
        .map(itm => reports.charts.find(x => x._id === itm._id) || null)
        .filter(y => y != null);

      this.setState({ chartOrder: orderedCharts });
      if (reports.charts.length == 0) {
        this.setState({ isEmpty: true });
      }
    }

    // console.log('current_st: ', current_st)
    // console.log('prev_st: ', prev_st)
    // if(current_st!=null && current_st.length!=prev_st.length) {
    //   console.log('changes----')
    //   this.filterChartCategory(current_st)

    // }

    //   if( (reportCharts && prevProps.reportCharts) && (prevProps.reportCharts.length != reportCharts.length)){
    //
    //     this.setState({chartOrder: this.props.reportCharts})
    //   }
  }

  updateChartComplete = chart => {
    let { chartOrder, chartsUpdated } = this.state;

    let { charts } = this.props.reports;
    console.log("chartList : ", charts);

    // let res = chartOrder.map(e=>{
    //   if(e._id==chart._id){
    //     e = {...chart, isUpdateData:null}
    //   }
    //   return e
    // })

    // this.setState({ chartOrder:charts})
  };

  updateAllCharts = dashboardDateUpdate => {
    let { chartOrder } = this.state;
    let res = chartOrder.map(e => {
      return { ...e, isUpdateData: true };
    });
    this.setState({
      chartOrder: res,
      chartsUpdated: 0,
      dashboardDateUpdate,
    });
  };

  fetchCharts = () => {
    console.log("fetch charts ----");
    let { currentDashboard } = this.state;
    let that = this;

    axios
      .post(url.getDashboardCharts, { dashboardId: currentDashboard._id })
      .then(({ data }) => {
        let result = data && data.data && data.data.length > 0 ? data.data : [];
        let isEmpty = result.length == 0 ? true : false;

        that.props.addReportCharts(result);

        let dashboard_order = [];
        if (
          currentDashboard.chartOrder &&
          Array.isArray(currentDashboard.chartOrder) &&
          currentDashboard.chartOrder.length
        ) {
          const resultIdObjMap = {};

          result.forEach(element => {
            resultIdObjMap[element._id] = element;
          });

          dashboard_order = currentDashboard.chartOrder.map(x => ({
            ...resultIdObjMap[x],
          }));
          dashboard_order = dashboard_order.filter(x => !blankObj(x));

          const newData = result.filter(
            x => !currentDashboard.chartOrder.includes(x._id)
          );

          //get newly added chart into order who is not present in currentDashboard.chartOrder

          dashboard_order = [...dashboard_order, ...newData];

          //console.log(dashboard_order);
        } else {
          dashboard_order = result;
        }

        that.setState({
          // allItems:result,
          // dashboardDateUpdate:this.props.reports.dashboardDateUpdate
          currentDashboard,
          chartOrder: dashboard_order,
          // isEmpty,
        });
      })
      .catch(err => {
        console.log("dbchlist: ", err);
      })
      .finally(() => {
        let { chartOrder } = this.state;
        if (chartOrder.length == 0) {
          this.setState({ isEmpty: true });
        }
      });
  };

  editLinkedItem = (item, type) => {
    let {
      allItems,
      searchedTerm,
      charts,
      currentDashboard,
      tools,
    } = this.state;
    if (type == 1) {
      if (
        (charts.length > 0 &&
          findIndex(charts, c => {
            return item._id.toString() === c.itemId.toString();
          }) === -1) ||
        charts.length == 0
      ) {
        // let position = charts.length==0?0:charts.length-1
        let obj = {
          itemId: item._id,
          date: new Date(),
          name: item.name,
          col_size: 4, // medium: col-lg-4, large: col-lg-6, sm: col-lg-3
          addedBy: {
            _id: this.props.user.profile._id,
            firstName: this.props.user.profile.firstName,
            lastName: this.props.user.profile.lastName,
          },
          model: "Chart",
          type: "stored", //vs adhoc like user count
          organizationId: this.props.user.profile.organizationId._id,
        };

        let index = allItems.findIndex(el => el._id == item._id);

        // let res = charts.concat(obj)
        let res = [obj, ...currentDashboard];
        item = { ...item, selected: true, type: obj.type };
        allItems[index] = item;

        let stateObj = { charts: res, allItems };

        if (searchedTerm.length === 0) {
          stateObj = { ...stateObj, linkedItems: allItems };
        }
        this.setState(stateObj);
      } else {
        let mod_chart = filter(
          charts,
          c => c.itemId.toString() != item._id.toString()
        );
        let index = allItems.findIndex(
          el => el._id.toString() == item._id.toString()
        );
        // let mod_attached = filter(attachedChartItems, (c) => c.itemId.toString() != item._id);
        allItems[index].selected = null;
        allItems[index].type = null;
        // allItems[index]
        // allItems = sortBy(allItems, ['type','lastUpdate.dateTime']);
        this.setState({ charts: mod_chart, linkedItems: allItems, allItems });
      }
    }

    // if want to link items...
    if (type == 2) {
      let tools =
        currentDashboard &&
        currentDashboard.tools &&
        currentDashboard.tools.length > 0
          ? currentDashboard.tools.map(e => e.itemId)
          : [];

      if (
        (tools.length > 0 &&
          findIndex(tools, tool => {
            return item._id.toString() === tool.itemId.toString();
          }) === -1) ||
        tools.length == 0
      ) {
        let obj = {
          itemId: item._id,
          date: new Date(),
          user: this.props.user.profile._id,
          firstName: this.props.user.profile.firstName,
          lastName: this.props.user.profile.lastName,
          type: "OfficeToolkit",
          organizationId: this.props.user.profile.organizationId._id,
        };

        let index = allItems.findIndex(el => el._id == item._id);

        let result = tools.concat(obj);
        item = { ...item, selected: true, type: obj.type };
        allItems[index] = item;

        // if(allItems && allItems.length>0){
        //   allItems.splice(index,1)
        //   allItems.splice(0,0, item)
        // } else {
        //   allItems.push(item)
        // }
        // allItems = sortBy(allItems, ['type','lastUpdate.dateTime']);

        // let attachedItm = {...obj, ...item}
        // attachedChartItems.push(attachedItm)

        let stateObj = { tools: result, allItems };

        if (searchedTerm.length === 0) {
          stateObj = { ...stateObj, linkedItems: allItems };
        }

        this.setState(stateObj);
      } else {
        let mod_tool = filter(
          tools,
          c => c.itemId.toString() != item._id.toString()
        );
        let index = allItems.findIndex(
          el => el._id.toString() == item._id.toString()
        );

        // let mod_attached = filter(attachedChartItems, (c) => c.itemId.toString() != item._id);

        allItems[index].selected = null;
        allItems[index].type = null;

        // allItems = sortBy(allItems, ['type','lastUpdate.dateTime']);
        this.setState({ tools: mod_tool, linkedItems: allItems, allItems });
      }
    }
  };

  getItems = item => {
    let { currentDashboard } = this.state;
    if (item == "C") {
      let payload = {
        category: "All",
        pageNumber: 0,
        count: "all",
        linkedCharts:
          currentDashboard &&
          currentDashboard.charts &&
          currentDashboard.charts.length > 0
            ? currentDashboard.charts.map(e => e.itemId)
            : [],
      };

      axios.post(url.fetchCharts, payload).then(({ data }) => {
        let result = data.data;
        this.setState({
          allItems: result,
          linkedItems: result,
          linkedItemsCount: result.length,
          isResourceSelect: 1,
        });
      });
    }

    if (item == "T") {
      let payload = {
        category: "All",
        pageNumber: 0,
        count: "all",
        linkedTools:
          currentDashboard &&
          currentDashboard.tools &&
          currentDashboard.tools.length > 0
            ? currentDashboard.tools.map(e => e.itemId)
            : [],
      };
      axios
        .post(url.fetchTools, payload)
        .then(({ data }) => {
          let result = data.data;
          this.setState({
            allItems: result,
            linkedItems: result,
            linkedItemsCount: result.length,
            isResourceSelect: 2,
          });
        })
        .catch(error => {
          //todo show error
        });
    }

    if (item == "U") {
      this.setState({ isUploadFiles: true });
    }
  };

  handleSearchQueryChanged = ({ target }) => {
    const { name, value } = target;
    let { allItems, linkedItems } = this.state;
    let list = [];
    linkedItems = allItems;
    if (value.length === 0) {
      list = allItems;
    } else {
      linkedItems = filter(linkedItems, itm =>
        itm.name.toLowerCase().includes(value.toLowerCase())
      );
    }
    this.setState({
      linkedItems,
      searchedTerm: value,
    });
  };

  isItemLinked = (itm, type) => {
    let { currentDashboard, charts, tools } = this.state;

    if (type == 1) {
      return (
        findIndex(charts, ch => {
          return itm._id === ch.itemId.toString();
        }) > -1
      );
    }

    if (type == 2) {
      return (
        findIndex(tools, tool => {
          return itm._id === tool.itemId.toString();
        }) > -1
      );
    }
  };

  closeActionsModal = () => {
    let { chartOrder } = this.state;
    this.setState({
      isResourceSelect: null,
      charts: chartOrder,
    });
    this.props.closeActionsModal();
  };

  attachDashboardItems = () => {
    let { chartOrder, currentDashboard, charts } = this.state;
    let old_chart_length = chartOrder.length;
    let new_chart_length = charts.length;
    let length_df = new_chart_length - old_chart_length,
      items_array = charts.map(e => e.itemId);

    // this.setState({length_df,  isResourceSelect:null  })

    let payload = {
      linkedCharts: items_array,
      category: "All",
    };

    if (items_array && items_array.length > 0) {
      axios.post(url.fetchAttachedCharts, payload).then(({ data }) => {
        let result = data.data;
        // result = result.map(e=>{
        //   let extra_attr =  filter(charts, (c) => c.itemId.toString() == e._id.toString() );
        //   return {...e, goals:[], comments:[], chartId: e._id,
        //           createdBy: this.props.user.profile._id,
        //           dashboardId:currentDashboard._id,
        //           createdDate:new Date(),
        //           // _id:null,
        //           col_size: extra_attr.length>0? extra_attr[0].col_size: 4,
        //           attachedDate: extra_attr.length>0?extra_attr[0].date:null}
        // })
        this.setState({
          newCharts: result,
          chartOrder: result,
          isResourceSelect: null,
          length_df,
        });
        this.props.setCharts(result);
      });
    }
  };

  handleScroll = e => {
    // const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    let bottom = e.target.scrollHeight - e.target.offsetHeight;
    let { scrollHeight, offsetHeight, scrollTop } = e.target;

    if (e.target.scrollTop >= bottom) this.loadMore();
  };

  navigateAnalytics = () => {
    this.props.history.push("/home/analytics/all");
  };

  changeSize = chart => {
    let { chartOrder } = this.state;
    console.log("size-changed");
    let res = chartOrder.map(e => {
      if (e._id == chart._id) {
        e = chart;
      }
      return e;
    });

    console.log("nn", res);

    this.setState({ chartOrder: res });
  };

  onSortEnd = (oldIndex, newIndex) => {
    this.setState({
      chartOrder: arrayMoveImmutable(this.state.chartOrder, oldIndex, newIndex),
    });

    // dashboardId the dashboard id
    // chartId the chart id
    let { currentDashboard } = this.props;

    axios
      .post(url.changeChartIndex, {
        dashboardId: currentDashboard._id,
        chartOrder: this.state.chartOrder,
      })
      .then(({ data }) => {
        let resp = data.data;
        console.log("success ---", resp);
      })
      .catch(error => {
        console.log(error);
      });
  };

  dashboardChartView = () => {
    let {
      chartOrder,
      isResourceSelect,
      charts,
      searchedTerm,
      linkedItems,
    } = this.state;
    let { isCategory } = this.props.reports;
    return (
      <div className="dashboardChartListContainer">
        <SortableList onSortEnd={this.onSortEnd} draggedItemClassName="dragged">
          {chartOrder.length > 0
            ? chartOrder.map((itm, idx) => {
                return (
                  <SortableItem key={itm._id}>
                    <div
                      key={itm._id + idx}
                      className={`dashboardPreviewContainerItem cursor-pointer ${
                        dashboardChartSize[itm.col_size]["size"]
                      } 
                              ${
                                isCategory &&
                                isCategory.length > 0 &&
                                isCategory.indexOf(itm.category) == -1
                                  ? "hide"
                                  : ""
                              }`}
                    >
                      <DashboardChartItem
                        isResourceSelect={isResourceSelect}
                        chart={itm}
                        chart_id={itm._id}
                        modifyChart={this.modifyChart}
                        currentDashboard={this.props.currentDashboard}
                        changeSize={this.changeSize}
                        chartOrder={this.state.chartOrder}
                      />

                      {/* <DashboardChartPlot 
                          chart={itm} 
                          modifyChart={this.modifyChart}
                          updateChartComplete={this.updateChartComplete}
                        /> */}

                      {/* </DashboardChartItem> */}
                    </div>
                  </SortableItem>
                );
              })
            : null}
        </SortableList>

        <Modal
          isOpen={isResourceSelect != null ? true : false}
          className="dashboardModalContainer dashboardCreateCLModal"
        >
          <ModalHeader
            className="dashboardHeader"
            charCode="X"
            toggle={() => this.closeActionsModal()}
          >
            <div className="dashboardModalTitle">
              Add to dashboard{" "}
              <span className="dashboardChartsAddSymbol">{charts.length}</span>
            </div>
          </ModalHeader>
          <ModalBody className="dashboardModalBody">
            <div className="dashboardModalBodyTxt">
              Select {isResourceSelect == 1 ? "chart(s)" : "toolkit resources"}{" "}
              to include on this dashboard.
            </div>

            <Input
              className="dashboardModalItemSearch"
              placeholder="Search by name"
              onChange={this.handleSearchQueryChanged}
              value={searchedTerm}
            />

            <div className="divTableBody" onScroll={this.handleScroll}>
              {linkedItems && linkedItems.length > 0
                ? linkedItems.map((itm, idx) => {
                    return (
                      <span key={itm._id + idx} className="singleTaskLinkItem">
                        <Checkbox
                          className="singleTaskLinkCheckBox"
                          checked={this.isItemLinked(itm, isResourceSelect)}
                          type="checkbox"
                          onClick={() =>
                            this.editLinkedItem(itm, isResourceSelect)
                          }
                        />
                        {itm.name}
                      </span>
                    );
                  })
                : null}
            </div>

            <div
              className="singleTaskModalBtn"
              style={{ padding: "10px 0px 0px 0px" }}
            >
              <Button
                className={`profile-modal-save-btn float-left weeklyWinBtn ${
                  charts.length === 0 ? "disabled opacity40" : ""
                }`}
                onClick={
                  charts.length > 0 ? () => this.attachDashboardItems() : null
                }
              >
                <span className="profile-modal-save-btn-txt">
                  (Un)Attach
                  <span className="ml10 flaticon-tick"></span>
                </span>
              </Button>

              <Button
                className="profile-modal-cancel-btn float-right weeklyWinBtn"
                onClick={() => this.closeActionsModal()}
              >
                <span className="profile-modal-cancel-btn-txt">Cancel</span>
              </Button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  };

  loadingDashboardsCharts = () => {
    return (
      <span className="dashboardTableList">
        <Table responsive hover className="">
          <thead>
            <tr className="dashboardListHeaders">
              <th>Name</th>
              <th>Owner</th>
              <th>Access</th>
              <th>Last Updated</th>
            </tr>
          </thead>
          <tbody>
            <tr className="dashboardListRows">
              <td>
                <span className="dashboardListSingleLink"> Loading...</span>
              </td>

              <td>
                <span className="dashboardListSingleOwner">Loading...</span>
              </td>

              <td>
                <span className="dashboardListAccessValue">Loading...</span>
              </td>

              <td>
                <div className="lastUpdateDate"> Loading...</div>
              </td>
            </tr>
          </tbody>
        </Table>
      </span>
    );
  };

  noDashoardCharts = () => {
    return (
      <div className="dashboardChartListContainer">
        <div className="dashboardAddChartContainer">
          {/* <div class="content-overlay"></div> */}
          <span className="dashboardAddChartImgContainer">
            <img
              src={NoKpiPlaceholder}
              onClick={() => this.navigateAnalytics()}
            />
            <span
              className="dashboardAddChartTxt"
              onClick={() => this.navigateAnalytics()}
            >
              Click here to add charts from Analytics
            </span>
          </span>
        </div>
      </div>
    );
  };

  renderView = () => {
    let { chartOrder, isEmpty } = this.state;

    if (chartOrder.length > 0) {
      return (
        <div>
          <div className="dashboard-chart-sort-instruction">
            <BsInfoCircle />

            <span>
              {" "}
              Please click and hold on the tiles to drag and drop the order of
              the chart.{" "}
            </span>
          </div>
          {this.dashboardChartView()}{" "}
        </div>
      );
    } else if (chartOrder.length == 0) {
      if (isEmpty) {
        return this.noDashoardCharts();
      } else {
        return this.loadingDashboardsCharts();
      }
    }
  };

  render() {
    return !this.props.reports.hideCharts ? this.renderView() : null;
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    reportCharts: state.reports.charts,
    reports: state.reports,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onKpiMasterListFetched: data =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: data =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: data =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: header => dispatch(actionCreators.navBarUpdate(header)),
    addReportCharts: charts => dispatch(actionCreators.addReportCharts(charts)),
    updateReport: dashboard => dispatch(actionCreators.updateReport(dashboard)),
  };
};

// export default LinkedCharts;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(DashboardChartList, axios)));
